import { render } from "./route-view.vue?vue&type=template&id=537a45e8&ts=true"
import script from "./route-view.vue?vue&type=script&lang=ts"
export * from "./route-view.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__